import { CheckboxIcon, CheckboxIndeterminateIcon, CheckboxSelectedIcon } from '#icons';
import { ThemeOptions } from '@mui/material';

/**
 * View Checkbox props and classes at https://mui.com/material-ui/api/checkbox/#css
 */
export const checkbox: ThemeOptions['components'] = {
  MuiCheckbox: {
    defaultProps: {
      icon: <CheckboxIcon />,
      checkedIcon: <CheckboxSelectedIcon />,
      indeterminateIcon: <CheckboxIndeterminateIcon />,
    },
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        borderRadius: '6px',
        '& svg': {
          height: '20px',
          width: '20px',
        },
        ...(ownerState.size === 'small' && {
          padding: theme.spacing(0.5),
        }),
        ...(ownerState.size === 'medium' && {
          padding: theme.spacing(0.75),
        }),
      }),
    },
  },
};
